import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'
import {
    tvBlueLinkButtonColor,
    tvProductNameTextColor,
    tvProductNameTextHoverColor,
} from 'bpm/shared/bpmColors'

interface ProductListingsPageStyleProps {
    hasLowerBottomToolbar?: boolean
}

const useProductListingStyle = makeStyles((theme: Theme) => ({
    container: {
        height: '100%',
        marginRight: -theme.spacing(3),
        marginLeft: -theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            width: 'calc(100% + 40px)',
        },
        [theme.breakpoints.up('sm')]: {
            width: 'calc(100% + 48px)',
        },
    },
    productSearchContOuter: {
        [theme.breakpoints.down('sm')]: {
            height: 94,
        },
        [theme.breakpoints.up('md')]: {
            height: 60,
        },
        zIndex: 1,
    },
    notesButton: {
        color: tvBlueLinkButtonColor,
        fontWeight: 'normal',
        width: '100%',
        padding: theme.spacing(0, 1),
        textAlign: 'left',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: 'transparent',
        },
        '&>.MuiButton-label': {
            display: 'unset',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
    productContent: (props: ProductListingsPageStyleProps) => ({
        height: `calc(100vh - ${
            props.hasLowerBottomToolbar ? '244px' : '215px'
        })`,
        [theme.breakpoints.up('md')]: {
            height: 'calc(100vh - 215px)',
        },
        width: '100%',
        overflow: 'hidden',
        marginTop: pxToRem(15),
    }),
    resultContainer: {
        width: '100%',
        paddingTop: theme.spacing(4),
        height: '100%',
        margin: 0,
        overflow: 'hidden',
        overflowY: 'auto',
        overscrollBehavior: 'none',
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    specTableContainer: {
        maxHeight: '30px',
    },
    productNameText: {
        color: tvProductNameTextColor,
        '&:hover': {
            color: tvProductNameTextHoverColor,
        },
    },
}))

export { useProductListingStyle }
